export default __webpack_public_path__ + "static/media/eseBus_app_icon.3b7b18e9.svg";